import React, { useEffect } from 'react'
import SelectWrapped from './SelectWrapped'
import { formatContentSelectValueSingle, filterOptionsFunction } from '../utils'
import TextField from '@material-ui/core/TextField'
import { connect } from 'react-redux'
import { searchTableActions } from '../actions'
import Select from 'react-select'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  '@global': {
    '.Select': {
      'min-height': '40px',
      'min-width': '300px',
      'margin-right': '16px',
      'box-shadow':
        '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
      background: 'transparent',
      'border-radius': '4px'
    },
    '.Select-control': {
      'min-height': '40px',
      'min-width': '300px',
      'border-color': '#ccc !important',
      'box-shadow': 'unset !important'
    },
    '.Select-placeholder': {
      'line-height': '40px'
    },
    '.Select-value-label': {
      'line-height': '40px'
    }
  }
})

const FilterSelect = ({
  // original props
  isDisabled = false,
  error = false,
  label = '',
  loadOptions = null,
  options = [],
  placeholder = 'Selecione um valor...',
  loadingPlaceholder = 'Carregando...',
  searchPromptText = 'Digite para buscar...',
  noResultsText = 'Nenhum resultado econtrado',

  // from redux
  filter,
  clearFilter,
  changeFilter
}) => {
  useEffect(() => {
    return clearFilter
  }, [])

  const SelectComponent = loadOptions ? Select.Async : Select

  return (
    <SelectComponent
      onChange={evt => changeFilter(evt)}
      isClearable
      isDisabled={isDisabled}
      searchPromptText={searchPromptText}
      noResultsText={noResultsText}
      placeholder={placeholder}
      loadingPlaceholder={loadingPlaceholder}
      filterOptions={filterOptionsFunction}
      value={
        !!Object.keys(filter || {}).length ? formatContentSelectValueSingle(filter || {}) : null
      }
      multi={false}
      loadOptions={loadOptions}
    />
  )
}

const mapStateToProps = state => {
  return {
    filter: state.searchTable.filter
  }
}

const mapDispatchToProps = dispatch => {
  return {
    changeFilter: filter => {
      dispatch(searchTableActions.changeFilter(filter))
    },
    clearFilter: () => {
      dispatch(searchTableActions.clearFilter())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(FilterSelect))



// WEBPACK FOOTER //
// ./src/components/FilterSelect.js